module.exports = __webpack_public_path__ + "img/Individual Login.a511ecb5.jpg";